import { gql } from "@apollo/client";
import { CRMNote } from "@/types";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";

export type { CRMNote };

export const GET_COHORT_ENROLLMENT_NOTES_BY_UNIVERSITY_QUERY = gql`
  query GetCohortEnrollmentNotesByUniversity($universityId: ID!) {
    university(id: $universityId) {
      id
      name
      universityCohorts {
        id
        name
        enrollments {
          id
          person {
            id
            firstName
            lastName
          }
          status
          notes {
            ...CRMNoteFields
          }
        }
      }
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;

export type Person = {
  id: string;
  firstName: string;
  lastName: string;
};

export type Enrollment = {
  id: string;
  person: Person;
  status: string;
  notes: CRMNote[];
};

export type UniversityCohort = {
  id: string;
  name: string;
  enrollments: Enrollment[];
};

export type University = {
  id: string;
  name: string;
  universityCohorts: UniversityCohort[];
};

export type GetCohortEnrollmentNotesByUniversityQuery = {
  university: University;
};

export const GET_STUDENT_ENROLLMENT_QUERY = gql`
  query GetStudentEnrollment($personId: ID!, $universityId: ID) {
    person(id: $personId) {
      id
      universityCohortEnrollment(universityId: $universityId) {
        id
      }
    }
  }
`;

export type GetStudentEnrollmentQuery = {
  person: {
    id: string;
    universityCohortEnrollment: { id: string } | null;
  };
};
